import React from 'react';
import { AppName } from 'sl-api-connector';
import {
  AdManagerLogo,
  AdvisorLogo,
  AtlasLogo,
  BeaconLogo,
  DigitalShelfLogo,
  DiscoverLogo,
  OmniLogo,
  ShopperosLogo,
  ShopperosV2Logo,
  SvgElementProps,
  SyncLogo
} from 'src/components/SvgIcons/SvgIcons';
import { getAppName } from 'src/utils/app';

const LogoIcon = (props: SvgElementProps) => {
  const appName = getAppName();

  let LogoIconComponent = AdvisorLogo;
  if (appName === AppName.Atlas) {
    LogoIconComponent = AtlasLogo;
  } else if (appName === 'Advisor') {
    LogoIconComponent = AdvisorLogo;
  } else if (appName === 'AdManager') {
    LogoIconComponent = AdManagerLogo;
  } else if (appName === 'ShopperOS') {
    LogoIconComponent = ShopperosLogo;
  } else if (appName === 'ShopperOSV2') {
    LogoIconComponent = ShopperosV2Logo;
  } else if (appName === 'ShopperAnalytics') {
    LogoIconComponent = ShopperosLogo;
  } else if (appName === 'DigitalShelf') {
    LogoIconComponent = DigitalShelfLogo;
  } else if (appName === 'Sync') {
    LogoIconComponent = SyncLogo;
  } else if (appName === AppName.Omni) {
    LogoIconComponent = OmniLogo;
  } else if (appName === AppName.Beacon) {
    LogoIconComponent = BeaconLogo;
  } else if (appName === AppName.Discover) {
    LogoIconComponent = DiscoverLogo;
  } else {
    LogoIconComponent = AdManagerLogo;
  }

  return <LogoIconComponent {...props} />;
};

export default LogoIcon;
